import store from "../store";

export default async function isnt_pro_retoucher({ next, router }) {
    await store.dispatch('profile/role');
    let role = await store.getters['profile/role'];
    if (role === 'pro-retoucher') {
        return router.push({ name: "User Profile" });
    }

    return next();
}
